import DiscountTag from 'components/common/DiscountTag';
import StrikethroughSkeleton from 'components/common/StrikethroughSkeleton';
import Text from 'components/common/Text';
import useScreenSizeConstants from 'hooks/useScreenSizeConstants';

const TempoOrderSummaryPPS = ({ box, classes }) => {
  const { isMobileOrTablet } = useScreenSizeConstants();
  return (
    <>
      <div className={`${classes} flex justify-between pt-4`}>
        <Text brandStylesOverrides="font-medium text text-secondary" className="flex-1">
          Price Per Meal
        </Text>

        <Text brandStylesOverrides={'textMd flex font-medium text-tempo-black-100'}>
          {box?.promoApplied ? (
            <>
              <DiscountTag discountText={box.promo.displayedDiscount} />
              <StrikethroughSkeleton
                strikethroughText={box?.pricePerServingFormatted}
                textDisplayed={box?.promo?.pricePerServingFormatted}
                className="text-tempo-black-100"
              />
            </>
          ) : (
            box?.pricePerServingFormatted
          )}
        </Text>
      </div>
      {isMobileOrTablet && <div className="mt-4 border-t border-solid border-charcoal-60" />}
    </>
  );
};

TempoOrderSummaryPPS.propTypes = {
  classes: PropTypes.string,
  box: PropTypes.shape({
    promoApplied: PropTypes.bool.isRequired,
    pricePerServingFormatted: PropTypes.string.isRequired,
    promo: PropTypes.shape({
      pricePerServingFormatted: PropTypes.string,
      displayedDiscount: PropTypes.string,
    }),
  }),
};

export default TempoOrderSummaryPPS;
